<div class="container" *ngIf="processing && !error">
  <div
    class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
    role="progressbar"
    aria-valuenow="75"
    aria-valuemin="0"
    aria-valuemax="100"
    style="width: 75%"
  ></div>
  <h2 translate>SUBMITTING_ORDER</h2>
</div>

<div class="container" *ngIf="!!cultContext && !error">
  <div class="mb-4 text-center">
    <h2>
      <span translate>THANK_YOU_HEADER</span>
    </h2>
    <p>
      <span translate>ORDER_ID</span>:
      <a [href]="'orders/' + item" *ngFor="let item of cultContext.erpOrderIds; last as isLast"
        >{{ item }}<span *ngIf="!isLast">, </span></a
      >
    </p>
    <div *ngIf="!!cultContext.shipmentPrints">
      <p>
        <span translate>SHIPMENT_PRINTS</span>
        <span *ngFor="let shipmentPrint of cultContext.shipmentPrints; last as isLast">
          <a (click)="openShipmentPdfNewWindow(shipmentPrint)">
            {{ shipmentPrint.id }}
          </a>
          <span *ngIf="!isLast">, </span>
        </span>
      </p>
      <b><p translate>CLICK_SHIPMENT_PRINT</p></b>
    </div>
    <p translate>THANK_YOU_EMAIL_CONFIRMATION</p>
  </div>
</div>
<div class="container" *ngIf="error">
  <div class="mb-4">
    <p class="text-center">ERROR_OCCURED</p>
  </div>
</div>
